

export const orders = {
  "me": {
    "id": "374122be-fe0a-11e7-8e20-005056a0e04a",
    "nickname": "Colkors",
    "name": null,
    "picture": "https://cdn.xsolla.net/user-account/demo/avatar.jpg",
    "birthday": "1992-11-01",
    "first_name": "Colin",
    "last_name": "Korbin",
    "gender": "m"

  },
  "phone": {
    "phone_number": "+18777976552"
  },
  "email": {
    "current_email": "colkors@example.com",
    "email": "test@example.com"
  },
  "login_urls": [
    {
      "provider": "steam",
      "full_name": null,
      "social_id": "http://steamcommunity.com/openid/id/111111111111111",
      "picture": null,
      "nickname": "Colkors"
    },
    {
      "provider": "google",
      "full_name": null,
      "social_id": "nickname",
      "picture": null,
      "nickname": "Colin Korbin"
    }
  ],
  "shipping_addresses": [
    {
      "id": 38,
      "administrative_area": "Texas",
      "locality": "Longview",
      "address_line1": "3858 Hall Place",
      "address_line2": null,
      "room": null,
      "zip": "75604",
      "country": "USA",
      "country_iso": "US",
      "carrier_facility": null,
      "first_name": "Chris",
      "last_name": "Chris C Ramirez",
      "company": null,
      "phone": "+19037218368",
      "email": "random@example.com",
      "comment": null,
      "is_primary": 0
    },
    {
      "id": 39,
      "administrative_area": "Kansas",
      "locality": "ERIE",
      "address_line1": "2806 Coal Road",
      "address_line2": null,
      "room": null,
      "zip": "66733",
      "country": "USA",
      "country_iso": "US",
      "carrier_facility": null,
      "first_name": "Joseph",
      "last_name": "Taylor",
      "company": null,
      "phone": "+15707161378",
      "email": "jt@expample.com",
      "comment": null,
      "is_primary": 0
    }

  ],
  "social_providers": [
    {
      "provider": "baidu",
      "auth_url": "https://someurl1.com"
    },
    {
      "provider": "facebook",
      "auth_url": "https://someurl1.com"
    },
    {
      "provider": "github",
      "auth_url": "https://someurl1.com"
    },
    {
      "provider": "google",
      "auth_url": "https://someurl1.com"
    },
    {
      "provider": "linkedin",
      "auth_url": "https://someurl1.com"
    },
    {
      "provider": "naver",
      "auth_url": "https://someurl1.com"
    },
    {
      "provider": "reddit",
      "auth_url": "https://someurl1.com"
    },
    {
      "provider": "steam",
      "auth_url": "https://someurl1.com"
    },
    {
      "provider": "twitter",
      "auth_url": "https://twitter.com/login?lang=en"
    },
    {
      "provider": "vk",
      "auth_url": "https://someurl1.com"
    },
    {
      "provider": "wechat",
      "auth_url": "https://someurl1.com"
    }
  ],
  "sorders": [
    {
      "operation_id": 117004008,
      "date": "2018-01-10T07:59:28",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "//cdn.xsolla.net/img/misc/images/94dc7be93cdbbb5de3c6bfea2d8f4e31.png",
        "amount": 10
      },
      "purchase": {
        "virtual_item": [
          {
            "sku": "1475",
            "name": "Sheep",
            "description": "Sheep are quadrupedal, ruminant mammals typically kept as livestock.",
            "image": "//cdn.xsolla.net/img/misc/merchant-digital-goods/ea27a1a0577b2e4659b145626c3c3db9.png",
            "quantity": 1,
            "bonus_quantity": 0,
            "operation_type": "add"
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/img/misc/images/94dc7be93cdbbb5de3c6bfea2d8f4e31.png",
            "amount": 10323.05
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 1234,
      "date": "2017-11-03 13:45",
      "type": "history.operation_type.in_game_purchase",
      "coupon": "coupon code with mask",
      "payment_details": {
        "operation_id": 1234567890,
        "payment_method": "PayPal",
        "amount": 0.03,
        "currency": "EUR"
      },
      "virtual_currency_payment_details": {
        "sku": "gold",
        "name": "GOLD",
        "image": null,
        "amount": 14
      },
      "purchase": {
        "virtual_item": [
          {
            "sku": "rabbit",
            "name": "Rabbit",
            "description": "MOOOORE Informaion",
            "image": null,
            "quantity": 1,
            "bonus_quantity": 0,
            "operation_type": "remove"
          }
        ],
        "virtual_currency": [
          {
            "sku": "gold",
            "name": "GOLD",
            "image": null,
            "amount": -2.00,
            "bonus_amount": 0
          },
          {
            "sku": "gold",
            "name": "SILVER",
            "image": "URL",
            "amount": 2.00,
            "bonus_amount": 0
          }
        ],
        "subscription": [
          {
            "subscription_id": 12345,
            "product": "product name",
            "plan": "plan name",
            "operation_type": "history.operation_type.subscription.status_change",
            "change_status": "asd",
            "change_plan": {
              "old_plan": "old plan name",
              "new_plan": "new plan name"
            }
          }
        ],
        "physical_good":{
          "items":[
            {
              "sku": "speaker_hat",
              "name": "Speaker Hat",
              "description": "MOOOORE Informaion",
              "image": null,
              "quantity": 1,
              "bonus_quantity": 0
            }
          ],
          "shipping": {
            "address": "{\"first_name\":\"Craig\",\"last_name\":\"Terry\",\"email\":\"craigterry51@yahoo.com\",\"phone\":\"15597279188\",\"country\":\"USA\",\"country_iso\":\"US\",\"postal_code\":\"95945\",\"administrative_area\":\"California\",\"locality\":\"Grass Valley \",\"street_address\":\"408 Colfax Ave STE 4\",\"room\":\"\",\"comment\":\"\"}",
            "delivery_status": "history.physical_good_delivery_status.sent",
            "tracking_id": "234567890"
          }
        }
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": "gold",
            "name": "GOLD",
            "image": null,
            "amount": 0.00
          }
        ]
      },
      "xsolla_wallet": {
        "amount": 0.00,
        "currency": "USD"
      }
    },
    {
      "operation_id": 117003993,
      "date": "2018-01-10T07:59:20+00:00",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "https://cdn.xsolla.net/img/misc/images/94dc7be93cdbbb5de3c6bfea2d8f4e31.png",
        "amount": 10
      },
      "purchase": {
        "virtual_item": [
          {
            advertisement_type: null,
            amount: 1.99,
            amount_without_discount: 1.99,
            bonus_virtual_currency: [],
            bonus_virtual_items: [],
            can_be_added_to_favorite: true,
            currency: "USD",
            description: "Conquer your foes with vindication using the Basic Blaster! ",
            discount_percent: false,
            id: 159428,
            image: "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
            is_favorite: 0,
            label: null,
            long_description: "Conquer your foes with vindication using the Basic Blaster! Conquer your foes with vindication using the Basic Blaster!",
            name: "Xsolla Basic Blaster 1",
            offer_label: "",
            promotion_end_time: null,
            quantity_limit: 0,
            sku: "gun_1",
            try_it_url: null,
            unsatisfied_inventory_conditions: [],
            unsatisfied_user_attributes: [],
            vc_amount: 0,
            vc_amount_without_discount: 0,
            vc_discount_percent: false,

            bonus_quantity: 0,
            operation_type: "history.operation_type.digital_good.add",
            quantity: 1,
          },
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "https://cdn.xsolla.net/img/misc/images/94dc7be93cdbbb5de3c6bfea2d8f4e31.png",
            "amount": 10333.05
          }
        ],
        "xsolla_wallet": null
      }
    }
  ],
  "orders": [
    {
      "operation_id": 95806539,
      "date": "2017-11-03 13:45",
      "type": "history.operation_type.payment",
      "coupon": null,
      "payment_details": {
        "operation_id": 277129328,
        "payment_method": "Ваш баланс",
        "amount": 0,
        "currency": "USD"
      },
      "virtual_currency_payment_details": null,
      "purchase": {
        "virtual_item": [
          {
            advertisement_type: null,
            amount: 1.99,
            amount_without_discount: 1.99,
            bonus_virtual_currency: [],
            bonus_virtual_items: [],
            can_be_added_to_favorite: true,
            currency: "USD",
            description: "Conquer your foes with vindication using the Basic Blaster! ",
            discount_percent: false,
            id: 159428,
            image: "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
            is_favorite: 0,
            label: null,
            long_description: "Conquer your foes with vindication using the Basic Blaster! Conquer your foes with vindication using the Basic Blaster!",
            name: "Xsolla Basic Blaster 1",
            offer_label: "",
            promotion_end_time: null,
            quantity_limit: 0,
            sku: "gun_1",
            try_it_url: null,
            unsatisfied_inventory_conditions: [],
            unsatisfied_user_attributes: [],
            vc_amount: 0,
            vc_amount_without_discount: 0,
            vc_discount_percent: false,

            bonus_quantity: 0,
            operation_type: "history.operation_type.digital_good.add",
            quantity: 1,
          },
          {
            advertisement_type: null,
            amount: 1.99,
            amount_without_discount: 1.99,
            bonus_virtual_currency: [],
            bonus_virtual_items: [],
            can_be_added_to_favorite: true,
            currency: "USD",
            description: "Chrome and Blue make the enemies go BOOM! - The Empire",
            discount_percent: false,
            id: 160293,
            image: "//cdn3.xsolla.com/img/misc/images/0022d709c53e8ab27ff4c3b2aacda9af.png",
            is_favorite: 0,
            label: null,
            long_description: "",
            name: "Empire Basic Blaster",
            offer_label: "",
            promotion_end_time: null,
            quantity_limit: 0,
            sku: "gun_2",
            try_it_url: null,
            unsatisfied_inventory_conditions: [],
            unsatisfied_user_attributes: [],
            vc_amount: 0,
            vc_amount_without_discount: 0,
            vc_discount_percent: false,

            bonus_quantity: 0,
            operation_type: "history.operation_type.digital_good.add",
            quantity: 1,
          },
          {
            advertisement_type: null,
            amount: 100,
            amount_without_discount: 100,
            bonus_virtual_currency: [],
            bonus_virtual_items: [],
            can_be_added_to_favorite: true,
            currency: "USD",
            description: "Take it, take it all! All of Xsollas riches in one Mega Booster.",
            discount_percent: false,
            id: 160142,
            image: "//cdn3.xsolla.com/img/misc/images/e9f2f4a634bc96ea03b5d5ceadd7c55f.png",
            is_favorite: 0,
            label: null,
            long_description: "Booster Max",
            name: "Xsolla Booster Mega",
            offer_label: "",
            promotion_end_time: null,
            quantity_limit: 0,
            sku: "booster_mega_1",
            try_it_url: null,
            unsatisfied_inventory_conditions: [],
            unsatisfied_user_attributes: [],
            vc_amount: 0,
            vc_amount_without_discount: 0,
            vc_discount_percent: false,

            bonus_quantity: 0,
            operation_type: "history.operation_type.digital_good.add",
            quantity: 1,
          },
        ],
        "virtual_currency": [
          {
            "sku": "gold",
            "name": "GOLD",
            "image": "https://res.cloudinary.com/maiik/image/upload/v1567205189/Xsolla_Store_icons/ic_coins_vc.svg",
            "amount": -2.00,
            "bonus_amount": 0
          },
          {
            "sku": "gold",
            "name": "SILVER",
            "image": null,
            "amount": 2.00,
            "bonus_amount": 0
          }
        ],
        "subscription": [
          {
            "subscription_id": 12345,
            "product": "product name",
            "plan": "plan name",
            "operation_type": "history.operation_type.subscription.status_change",
            "change_status": "new status after operation",
            "change_plan": {
              "old_plan": "old plan name",
              "new_plan": "new plan name"
            }
          }
        ],
        "physical_good":{
          "items":[
            {
              advertisement_type: null,
              amount: 2.99,
              amount_without_discount: 2.99,
              bonus_virtual_currency: [],
              bonus_virtual_items: [],
              can_be_added_to_favorite: true,
              currency: "USD",
              description: "Protect your noggin' with style",
              discount_percent: false,
              id: 160314,
              image: "//cdn3.xsolla.com/img/misc/images/86a89eb32fcf897b98908d73ac3458c1.png",
              is_favorite: 0,
              label: null,
              long_description: "",
              name: "Empire Helmet",
              offer_label: "",
              promotion_end_time: null,
              quantity_limit: 0,
              sku: "helmet_2",
              try_it_url: null,
              unsatisfied_inventory_conditions: [],
              unsatisfied_user_attributes: [],
              vc_amount: 0,
              vc_amount_without_discount: 0,
              vc_discount_percent: false,

              bonus_quantity: 0,
              operation_type: "history.operation_type.digital_good.add",
              quantity: 1,
            },
          ],
          "shipping": {
            "address": "{\"first_name\":\"Craig\",\"last_name\":\"Terry\",\"email\":\"craigterry51@yahoo.com\",\"phone\":\"15597279188\",\"country\":\"USA\",\"country_iso\":\"US\",\"postal_code\":\"95945\",\"administrative_area\":\"California\",\"locality\":\"Grass Valley \",\"street_address\":\"408 Colfax Ave STE 4\",\"room\":\"\",\"comment\":\"\"}",
            "delivery_status": "history.physical_good_delivery_status.ready",
            "tracking_id": "234567890"
          }
        },
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "https://res.cloudinary.com/maiik/image/upload/v1567205189/Xsolla_Store_icons/ic_coins_vc.svg",
            "amount": 10586.6
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 1234,
      "date": "2017-11-03 13:45",
      "type": "history.operation_type.in_game_purchase",
      "coupon": "coupon code with mask",
      "payment_details": {
        "operation_id": 1234567890,
        "payment_method": "PayPal",
        "amount": 0.03,
        "currency": "EUR"
      },
      "virtual_currency_payment_details": {
        "sku": "gold",
        "name": "GOLD",
        "image": null,
        "amount": 14
      },
      "purchase": {
        "virtual_item": [
          {
            advertisement_type: null,
            amount: 2.99,
            amount_without_discount: 2.99,
            bonus_virtual_currency: [],
            bonus_virtual_items: [],
            can_be_added_to_favorite: true,
            currency: "USD",
            description: "Protect your noggin' with style",
            discount_percent: false,
            id: 160314,
            image: "//cdn3.xsolla.com/img/misc/images/86a89eb32fcf897b98908d73ac3458c1.png",
            is_favorite: 0,
            label: null,
            long_description: "",
            name: "Empire Helmet",
            offer_label: "",
            promotion_end_time: null,
            quantity_limit: 0,
            sku: "helmet_2",
            try_it_url: null,
            unsatisfied_inventory_conditions: [],
            unsatisfied_user_attributes: [],
            vc_amount: 0,
            vc_amount_without_discount: 0,
            vc_discount_percent: false,

            bonus_quantity: 0,
            operation_type: "history.operation_type.digital_good.add",
            quantity: 1,
          },
        ],
        "virtual_currency": [
          {
            "sku": "gold",
            "name": "GOLD",
            "image": "https://res.cloudinary.com/maiik/image/upload/v1567205189/Xsolla_Store_icons/ic_coins_vc.svg",
            "amount": -2.00,
            "bonus_amount": 0
          },
          {
            "sku": "gold",
            "name": "SILVER",
            "image": null,
            "amount": 2.00,
            "bonus_amount": 0
          }
        ],
        "subscription": [
          {
            "subscription_id": 12345,
            "product": "product name",
            "plan": "plan name",
            "operation_type": "history.operation_type.subscription.status_change",
            "change_status": "new status after operation",
            "change_plan": {
              "old_plan": "old plan name",
              "new_plan": "new plan name"
            }
          }
        ],
        "physical_good":{
          "items":[
            {
              advertisement_type: null,
              amount: 2.99,
              amount_without_discount: 2.99,
              bonus_virtual_currency: [],
              bonus_virtual_items: [],
              can_be_added_to_favorite: true,
              currency: "USD",
              description: "Protect your noggin' with style",
              discount_percent: false,
              id: 160314,
              image: "//cdn3.xsolla.com/img/misc/images/86a89eb32fcf897b98908d73ac3458c1.png",
              is_favorite: 0,
              label: null,
              long_description: "",
              name: "Empire Helmet",
              offer_label: "",
              promotion_end_time: null,
              quantity_limit: 0,
              sku: "helmet_2",
              try_it_url: null,
              unsatisfied_inventory_conditions: [],
              unsatisfied_user_attributes: [],
              vc_amount: 0,
              vc_amount_without_discount: 0,
              vc_discount_percent: false,

              bonus_quantity: 0,
              operation_type: "history.operation_type.digital_good.add",
              quantity: 1,
            },
          ],
          "shipping": {
            "address": "{\"first_name\":\"Craig\",\"last_name\":\"Terry\",\"email\":\"craigterry51@yahoo.com\",\"phone\":\"15597279188\",\"country\":\"USA\",\"country_iso\":\"US\",\"postal_code\":\"95945\",\"administrative_area\":\"California\",\"locality\":\"Grass Valley \",\"street_address\":\"408 Colfax Ave STE 4\",\"room\":\"\",\"comment\":\"\"}",
            "delivery_status": "history.physical_good_delivery_status.ready",
            "tracking_id": "234567890"
          }
        }
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": "gold",
            "name": "GOLD",
            "image": null,
            "amount": 0.00
          }
        ]
      },
      "xsolla_wallet": {
        "amount": 0.00,
        "currency": "USD"
      }
    },
    {
      "operation_id": 110800899,
      "date": "2017-11-03 13:45",
      "type": "history.operation_type.coupon",
      "coupon": "**pka",
      "payment_details": null,
      "virtual_currency_payment_details": null,
      "purchase": {
        "subscription": [
          {
            "subscription_id": 16290505,
            "product": null,
            "plan": "package_recurrent_name_29177",
            "operation_type": "history.operation_type.coupon"
          }
        ]
      },
      "current_balance": {
        "virtual_currency": null,
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 117004008,
      "date": "2018-01-10T07:59:28",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
        "amount": 10
      },
      "purchase": {
        "virtual_item": [
          {
            advertisement_type: null,
            amount: 1.99,
            amount_without_discount: 1.99,
            bonus_virtual_currency: [],
            bonus_virtual_items: [],
            can_be_added_to_favorite: true,
            currency: "USD",
            description: "Conquer your foes with vindication using the Basic Blaster! ",
            discount_percent: false,
            id: 159428,
            image: "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
            is_favorite: 0,
            label: null,
            long_description: "Conquer your foes with vindication using the Basic Blaster! Conquer your foes with vindication using the Basic Blaster!",
            name: "Xsolla Basic Blaster 1",
            offer_label: "",
            promotion_end_time: null,
            quantity_limit: 0,
            sku: "gun_1",
            try_it_url: null,
            unsatisfied_inventory_conditions: [],
            unsatisfied_user_attributes: [],
            vc_amount: 0,
            vc_amount_without_discount: 0,
            vc_discount_percent: false,

            bonus_quantity: 0,
            operation_type: "history.operation_type.digital_good.add",
            quantity: 1,
          },
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10323.05
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 114174508,
      "date": "2017-11-03 13:45",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
        "amount": 0.85
      },
      "purchase": {
        "virtual_item": [
          {
            advertisement_type: null,
            amount: 1.99,
            amount_without_discount: 1.99,
            bonus_virtual_currency: [],
            bonus_virtual_items: [],
            can_be_added_to_favorite: true,
            currency: "USD",
            description: "Conquer your foes with vindication using the Basic Blaster! ",
            discount_percent: false,
            id: 159428,
            image: "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
            is_favorite: 0,
            label: null,
            long_description: "Conquer your foes with vindication using the Basic Blaster! Conquer your foes with vindication using the Basic Blaster!",
            name: "Xsolla Basic Blaster 1",
            offer_label: "",
            promotion_end_time: null,
            quantity_limit: 0,
            sku: "gun_1",
            try_it_url: null,
            unsatisfied_inventory_conditions: [],
            unsatisfied_user_attributes: [],
            vc_amount: 0,
            vc_amount_without_discount: 0,
            vc_discount_percent: false,

            bonus_quantity: 0,
            operation_type: "history.operation_type.digital_good.add",
            quantity: 1,
          },
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10523.05
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 114174500,
      "date": "2017-11-03 13:45",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": null,
        "amount": 0.85
      },
      "purchase": {
        "virtual_item": [
          {
            advertisement_type: null,
            amount: 1.99,
            amount_without_discount: 1.99,
            bonus_virtual_currency: [],
            bonus_virtual_items: [],
            can_be_added_to_favorite: true,
            currency: "USD",
            description: "Conquer your foes with vindication using the Basic Blaster! ",
            discount_percent: false,
            id: 159428,
            image: "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
            is_favorite: 0,
            label: null,
            long_description: "Conquer your foes with vindication using the Basic Blaster! Conquer your foes with vindication using the Basic Blaster!",
            name: "Xsolla Basic Blaster 1",
            offer_label: "",
            promotion_end_time: null,
            quantity_limit: 0,
            sku: "gun_1",
            try_it_url: null,
            unsatisfied_inventory_conditions: [],
            unsatisfied_user_attributes: [],
            vc_amount: 0,
            vc_amount_without_discount: 0,
            vc_discount_percent: false,

            bonus_quantity: 0,
            operation_type: "history.operation_type.digital_good.add",
            quantity: 1,
          },
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10523.05
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 110800854,
      "date": "2017-11-03 13:45",
      "type": "history.operation_type.coupon",
      "coupon": "***bit",
      "payment_details": null,
      "virtual_currency_payment_details": null,
      "purchase": {
        "virtual_item": [
          {
            advertisement_type: null,
            amount: 1.99,
            amount_without_discount: 1.99,
            bonus_virtual_currency: [],
            bonus_virtual_items: [],
            can_be_added_to_favorite: true,
            currency: "USD",
            description: "Conquer your foes with vindication using the Basic Blaster! ",
            discount_percent: false,
            id: 159428,
            image: "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
            is_favorite: 0,
            label: null,
            long_description: "Conquer your foes with vindication using the Basic Blaster! Conquer your foes with vindication using the Basic Blaster!",
            name: "Xsolla Basic Blaster 1",
            offer_label: "",
            promotion_end_time: null,
            quantity_limit: 0,
            sku: "gun_1",
            try_it_url: null,
            unsatisfied_inventory_conditions: [],
            unsatisfied_user_attributes: [],
            vc_amount: 0,
            vc_amount_without_discount: 0,
            vc_discount_percent: false,

            bonus_quantity: 0,
            operation_type: "history.operation_type.digital_good.add",
            quantity: 1,
          },
        ],
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 0,
            "bonus_amount": 0
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10523.9
          }
        ],
        "xsolla_wallet": null
      }
    }
  ],
  "forders": [
    {
      "operation_id": 114423618,
      "date": "2017-11-03 13:45",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
        "amount": 10
      },
      "purchase": {
        "virtual_item": [
          {
            "sku": "1475",
            "name": "Sheep",
            "description": "Sheep are quadrupedal, ruminant mammals typically kept as livestock.",
            "image": "//cdn.xsolla.net/img/misc/merchant-digital-goods/ea27a1a0577b2e4659b145626c3c3db9.png",
            "quantity": 1,
            "bonus_quantity": 0,
            "operation_type": "history.operation_type.digital_good.add"
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10513.05
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 114174508,
      "date": "2017-11-03 13:45",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
        "amount": 0.85
      },
      "purchase": {
        "virtual_item": [
          {
            "sku": "1488",
            "name": "Firework",
            "description": "",
            "image": "//cdn.xsolla.net/img/misc/merchant-digital-goods/f8f4dc69cbb4132cb70c7c54ab7a1a5d.png",
            "quantity": 1,
            "bonus_quantity": 0,
            "operation_type": "history.operation_type.digital_good.add"
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10523.05
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 63714014,
      "date": "2016-11-09T14:05:36+03:00",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
        "amount": 10
      },
      "purchase": {
        "virtual_item": [
          {
            "sku": "1475",
            "name": "Sheep",
            "description": "Sheep are quadrupedal, ruminant mammals typically kept as livestock.",
            "image": "//cdn.xsolla.net/img/misc/merchant-digital-goods/ea27a1a0577b2e4659b145626c3c3db9.png",
            "quantity": 1,
            "bonus_quantity": 0,
            "operation_type": "history.operation_type.digital_good.add"
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10553.25
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 63501919,
      "date": "2016-11-07T13:41:47+03:00",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
        "amount": 0.85
      },
      "purchase": {
        "virtual_item": [
          {
            "sku": "1488",
            "name": "Firework",
            "description": "",
            "image": "//cdn.xsolla.net/img/misc/merchant-digital-goods/f8f4dc69cbb4132cb70c7c54ab7a1a5d.png",
            "quantity": 1,
            "bonus_quantity": 0,
            "operation_type": "history.operation_type.digital_good.add"
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10563.25
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 63501870,
      "date": "2016-11-07T13:39:39+03:00",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
        "amount": 10
      },
      "purchase": {
        "virtual_item": [
          {
            "sku": "1475",
            "name": "Sheep",
            "description": "Sheep are quadrupedal, ruminant mammals typically kept as livestock.",
            "image": "//cdn.xsolla.net/img/misc/merchant-digital-goods/ea27a1a0577b2e4659b145626c3c3db9.png",
            "quantity": 1,
            "bonus_quantity": 0,
            "operation_type": "history.operation_type.digital_good.add"
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10564.1
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 62592038,
      "date": "2016-11-01T16:05:09+03:00",
      "type": "history.operation_type.payment",
      "coupon": null,
      "payment_details": {
        "operation_id": 235895888,
        "payment_method": "Ваш баланс",
        "amount": 0,
        "currency": "USD"
      },
      "virtual_currency_payment_details": null,
      "purchase": {
        "virtual_item": [
          {
            "sku": "1468",
            "name": "Rabbit",
            "description": "Rabbits are small mammals of the hare family.",
            "image": "https://cdn.xsolla.net/img/misc/merchant-digital-goods/4376c004fa33dc74483906561d617cb3.png",
            "quantity": 1,
            "bonus_quantity": 1,
            "operation_type": "history.operation_type.digital_good.add"
          }
        ],
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 100,
            "bonus_amount": 0
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 10584.95
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 43228081,
      "date": "2016-05-30T08:01:14+03:00",
      "type": "history.operation_type.coupon",
      "coupon": "**********jvr",
      "payment_details": null,
      "virtual_currency_payment_details": null,
      "purchase": {
        "subscription": [
          {
            "subscription_id": 5196042,
            "product": null,
            "plan": "Subscription",
            "operation_type": "history.operation_type.coupon"
          }
        ]
      },
      "current_balance": {
        "virtual_currency": null,
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 43227933,
      "date": "2016-05-30T07:58:55+03:00",
      "type": "history.operation_type.in_game_purchase",
      "coupon": null,
      "payment_details": null,
      "virtual_currency_payment_details": {
        "sku": null,
        "name": "Money",
        "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
        "amount": 0.85
      },
      "purchase": {
        "virtual_item": [
          {
            "sku": "1488",
            "name": "Firework",
            "description": "",
            "image": "//cdn.xsolla.net/img/misc/merchant-digital-goods/f8f4dc69cbb4132cb70c7c54ab7a1a5d.png",
            "quantity": 1,
            "bonus_quantity": 0,
            "operation_type": "history.operation_type.digital_good.add"
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 12300.4
          }
        ],
        "xsolla_wallet": null
      }
    },
    {
      "operation_id": 43227658,
      "date": "2016-05-30T07:55:05+03:00",
      "type": "history.operation_type.payment",
      "coupon": null,
      "payment_details": {
        "operation_id": 211415111,
        "payment_method": "WebMoney",
        "amount": 6,
        "currency": "USD"
      },
      "virtual_currency_payment_details": null,
      "purchase": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 100,
            "bonus_amount": 0
          }
        ]
      },
      "current_balance": {
        "virtual_currency": [
          {
            "sku": null,
            "name": "Money",
            "image": "//cdn.xsolla.net/user-account/demo/gold.svg",
            "amount": 12201.25
          }
        ],
        "xsolla_wallet": null
      }
    }
  ]
}



export const namedOrders = {
  'one': orders['orders'][0],
  'many': orders['orders'][0],
}


export const ordersgame = [
  {
    image_url: 'https://cdn3.xsolla.com/img/misc/images/8f71d99c7c5e68dbaf2bd3930186a2ca.png',
    localized_name: 'Blasphemous',
    drms: [
      'steam', 'switch', 'gog', 'ps4', 'xbox'
    ],
    defaultPrice: '$19.99',
  },
  {
    image_url: 'https://cdn3.xsolla.com/img/misc/images/01c0f2e4173cec05588391b3d57e28fd.jpg',
    localized_name: 'Planet Alpha',
    drms: [
      'steam', 'switch', 'gog', 'xbox'
    ],
    defaultPrice: '$9.99',
  },
  {
    image_url: 'https://cdn3.xsolla.com/img/misc/images/655f993b4be6daca74138364598b32cb.jpg',
    localized_name: 'Overcooked 2',
    drms: [
      'steam', 'switch', 'gog', 'xbox'
    ],
    defaultPrice: '$39.99',
  },
]